// extracted by mini-css-extract-plugin
module.exports = {"icon":"IdCardCard_icon__1rykU"};